import { render, staticRenderFns } from "./PickupStoreList.vue?vue&type=template&id=64e6942e&scoped=true"
import script from "./PickupStoreList.vue?vue&type=script&lang=js"
export * from "./PickupStoreList.vue?vue&type=script&lang=js"
import style0 from "./PickupStoreList.vue?vue&type=style&index=0&id=64e6942e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e6942e",
  null
  
)

export default component.exports